interface TrustedContactsIconProps {
  className?: string;
}

/**
 * An address-book card. Deliberately distinct from `PlayersIcon` (two filled figures): the two sit
 * six rows apart in the same sidebar, and a directory of outside coaches is not a roster.
 */
export const TrustedContactsIcon = ({ className }: TrustedContactsIconProps) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M5 2.5h11A1.5 1.5 0 0 1 17.5 4v12a1.5 1.5 0 0 1-1.5 1.5H5V2.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M5 5.5H3.25M5 10H3.25M5 14.5H3.25"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <circle cx="11" cy="8" r="2" fill="currentColor" />
    <path
      d="M7.75 14c0-1.5 1.455-2.5 3.25-2.5s3.25 1 3.25 2.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);
